import Check from '../Core/Check.js';

    /**
     * Clarity. Gets a GLSL snippet that includes or discards a fragment using a clipping volume.
     *
     * @param {Boolean} isolated Only display fragment if set.
     * @returns {String} A string containing GLSL that includes or discards the current fragment.
     * @private
     */
    function getClipVolumeAndStyleCode(isolated, transformName) {
        //>>includeStart('debug', pragmas.debug);
        Check.typeOf.bool('isolated', isolated);
        //>>includeEnd('debug');

        var operator = isolated ? '&& !' : '|| ';
        var shaderCode =
            '   mat4 transform; \n' +
            '   vec4 position; \n' +
            '   bool clipped = ' + isolated + '; \n' +
            '   vec4 boxMin = vec4(-0.5, -0.5, -0.5, 1.0); \n' +
            '   vec4 boxMax = vec4(0.5, 0.5, 0.5, 1.0); \n' +
            '   for (int i = 0; i < length; ++i) \n' +
            '   { \n' +
            '      transform = ' + transformName + '[i]; \n' + 
            '      vec4 min = boxMin; \n' +
            '      vec4 max = boxMax; \n' +
            '      position = transform * czm_windowToEyeCoordinates(gl_FragCoord); \n' + // position inside 1x1 cube
            '      clipped = clipped ' + operator + '(min.x < position.x && max.x > position.x && min.y < position.y && max.y > position.y && min.z < position.z && max.z > position.z); \n' + // check inside
            '   } \n' +
            '   if (clipped) discard; \n';
        return shaderCode;
    }

export default getClipVolumeAndStyleCode;
